import { IApplicationState } from '../../types/redux';
import { selectJsonQuery } from '../filters/selectJsonQuery';
import { dealTypeFromJsonQuery, FDealType } from '../../utils/category';

export const selectShowNewbuildingSeoBlock = (state: IApplicationState) => {
  const jsonQuery = selectJsonQuery(state);
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const isDailyRent = dealType === FDealType.RentDaily;

  return !isDailyRent;
};

export const selectNewbuildingSeoBlock = (state: IApplicationState) => {
  return state.newbuildingsSeoBlock;
};
